export default __webpack_public_path__ + "static/media/g-ul.73011290.jpg";